import { ExternalConnection } from "@shared/constants";
import { TenantConnectionConfig } from "@shared/utils";

export const config: TenantConnectionConfig<ExternalConnection | undefined> = {
  ig: {
    prod: "ig-sf",
    qa: "ig-sf-qa",
    staging: undefined, // no SSO on staging/localhost: the Auth0 page shows the client's other connections instead
  },
  "ig-dev": {
    qa: "ig-sf-dev",
    staging: "ig-sf-dev",
    demo: "ig-sf-dev",
  },
};
